import Cookies from 'js-cookie';
import decodeJWT from './token';
import TOKEN from 'constants/auth';

const setCookie = (accessToken, refreshToken) => {
	const { exp: access } = decodeJWT(accessToken);
	let refresh = null;
	if (refreshToken) ({ exp: refresh } = decodeJWT(refreshToken));

	const setExpires = exp => new Date(exp * 1000 + 9 * 60 * 60 * 1000);

	Cookies.set(TOKEN.ACCESS, accessToken, { expires: setExpires(access) });
	if (refreshToken)
		Cookies.set(TOKEN.REFRESH, refreshToken, { expires: setExpires(refresh) });
};

const removeCookie = () => {
	Cookies.remove(TOKEN.ACCESS);
	Cookies.remove(TOKEN.REFRESH);
};

export { setCookie, removeCookie };
